/**
 * Retro theme — bold honeycomb backdrop + very subtle paper grain.
 * No scanlines, no vignette, no broadcast ticker.
 */
export default function GlobalTextures() {
  return (
    <>
      <div
        className="fixed inset-0 bg-honeycomb bg-honeycomb-drift pointer-events-none"
        style={{ zIndex: 1, opacity: 0.95 }}
      />
      <div className="fixed inset-0 bg-noise pointer-events-none" style={{ zIndex: 2 }} />
    </>
  );
}
